import React from "react";
import { useIntl } from "react-intl";
import DensoLogo from "../../components/DensoLogo/DensoLogo";
import HeadingContainer from "../../containers/HeadingContainer";
import LoginOtpForm from "../../containers/LoginOtpForm/LoginOtpForm";
import AuthViewLayout from "../../layouts/AuthViewLayout/AuthViewLayout";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";

function LoginOtpFormView(props) {
  const intl = useIntl();
  return (
    <AuthViewLayout
      topSection={<DensoLogo />}
      middleSection={
        <HeadingContainer
          level={2}
          heading={getLocalizedMessage(intl, "login.enterOtp")}
          description={getLocalizedMessage(intl, "login.otpHasBeenShared")}
        />
      }
      bottomSection={<LoginOtpForm />}
    />
  );
}

export default LoginOtpFormView;
